import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { ServiceProvider } from "@gms/tsp-api";
import { select, Store } from "@ngrx/store";
import { IAppState } from "app/store/app/app.state";
import { selectRouteConfigs } from "app/store/auth/auth.selectors";
import { getSelectedInfoPostTSP } from "app/store/infopost/infopost.selectors";
import { IInfoPostState } from "app/store/infopost/infopost.state";
import { selectActivePrimaryNavMenuId, selectSelectedPrimaryNavConfig } from "app/store/sidebar/sidebar.selectors";
import { Observable } from "rxjs";
import { filter } from "rxjs/operators";
import { HasSubscriptions } from "shared/components/higher-order/has-subscriptions";
import { LABELS } from "shared/consts/labels.const";
import { SidebarService } from "shared/services/sidebar.service";
import { triggerSideNavItemSubMenu } from "./nav-menu.utils";

interface HasRoute {
    route?: string;
}

@Component({
    selector: 'nav-item-container-util',
    template: ''
})

export class NavItemContainerUtilComponent<T extends HasRoute> extends HasSubscriptions implements OnInit, OnDestroy {

    @Input()
    config: T;

    @Input()
    menuItemType: string = "";

    @Input()
    menuGuards: { [name: string]: Observable<boolean> };

    isAccessPage: boolean = false;

    selectedPrimaryNavConfig$ = this._store.pipe(select(selectSelectedPrimaryNavConfig));
    activePrimaryNavMenuId$ = this._store.pipe(select(selectActivePrimaryNavMenuId));
    routeConfigs$ = this._store.pipe(
        select(selectRouteConfigs),
        filter(Boolean)
    );

    headerState$: Observable<ServiceProvider> = this._infoStore.pipe(select(getSelectedInfoPostTSP));

    constructor(private _store: Store<IAppState>, private sharedService: SidebarService,
        private _infoStore: Store<IInfoPostState>, private _router: Router) {
        super();
    }

    ngOnInit() {

        

        this.addSubscriptions([
            this.headerState$.subscribe(resp => {
                this.isAccessPage = resp && Object.keys(resp).length > 0 || this.config.route === '/home';
            })
        ])
    }

    triggerSubMenu(e, config?: string): void {
        triggerSideNavItemSubMenu(e, this.sharedService, this.isAccessPage, this.menuItemType, this.config as any, this._router, this._store, config);
    }

}